import { HotelInfoModel } from '@/__generated';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

type Props = {
  hotelInfo: HotelInfoModel;
};

export default function Overview({ hotelInfo }: Props) {
  const description = React.useMemo(() => {
    return hotelInfo.description?.replaceAll('_x000D_', '<br/>') || '';
  }, [hotelInfo]);
  return (
    <div className="row y-gap-10 pt-20 ">
      <div className="col-12">
        <div className="rounded pl-10 pr-10 " style={{ backgroundColor: '#f0f8ff' }}>
          <h3 className="text-18 fw-500 pt-10">
            <i className="icon-award text-30 text-success mr-5" />
            Highlights
          </h3>
          <div className="mt-20 pb-10 d-block overflow-hidden overflow-scroll">
            <Swiper
              breakpoints={{
                540: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 5,
                },
                1300: {
                  slidesPerView: 6,
                },
              }}
            >
              {hotelInfo.englishCommunication ? (
                <SwiperSlide>
                  <div className="text-center px-10 py-10">
                    <img className="w-48" src="/static/icons/hotelHighlights/communication.svg" alt="English communication" />
                    <div className="fw-500 text-15 lh-11 mt-5">English communication</div>
                  </div>
                </SwiperSlide>
              ) : null}
              {hotelInfo.koreanCommunication ? (
                <SwiperSlide>
                  <div className="text-center px-10 py-10">
                    <img className="w-48" src="/static/icons/hotelHighlights/south-korea.svg" alt="Korean communication" />
                    <div className="fw-500 text-15 lh-11 mt-5">Korean communication</div>
                  </div>
                </SwiperSlide>
              ) : null}
              {hotelInfo.chineseCommunication ? (
                <SwiperSlide>
                  <div className="text-center px-10 py-10">
                    <img className="w-48" src="/static/icons/hotelHighlights/cn-flag-circle.png" alt="Chinese communication" />
                    <div className="fw-500 text-15 lh-11 mt-5">Chinese communication</div>
                  </div>
                </SwiperSlide>
              ) : null}

              {hotelInfo.hotelPools?.length ? (
                <SwiperSlide>
                  <div className="text-center px-10 py-10">
                    <img className="w-48" src="/static/icons/hotelHighlights/swimming-swimming-pool.svg" alt="Swimming pool" />
                    <div className="fw-500 text-15 lh-11 mt-5">Swimming pool</div>
                  </div>
                </SwiperSlide>
              ) : null}

              {hotelInfo.hotelBaths?.length ? (
                <SwiperSlide>
                  <div className="text-center px-10 py-10">
                    <img className="w-48" src="/static/icons/hotelHighlights/manicure.svg" alt="Spa" />
                    <div className="fw-500 text-15 lh-11 mt-5">Spa</div>
                  </div>
                </SwiperSlide>
              ) : null}
              {hotelInfo.hasParkingLot ? (
                <SwiperSlide>
                  <div className="text-center px-10 py-10">
                    <img className="w-48" src="/static/icons/hotelHighlights/parking.svg" alt="Parking" />
                    <div className="fw-500 text-15 lh-11 mt-5">Parking</div>
                  </div>
                </SwiperSlide>
              ) : null}

              <SwiperSlide>
                <div className="text-center px-10 py-10">
                  <img className="w-48" src="/static/icons/hotelHighlights/reception-receptionist.svg" alt="Front desk" />
                  <div className="fw-500 text-15 lh-11 mt-5">Front desk</div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
      <div className="col-12">
        <h3 className="text-22 fw-500 pt-30">Overview</h3>
        <p className="text-dark-1 text-15 mt-20" dangerouslySetInnerHTML={{ __html: description || '' }}></p>
      </div>
    </div>
  );
}
